import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.find";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.map";
import "core-js/modules/es.array.reduce";
import "core-js/modules/es.array.some";
import "core-js/modules/es.array.splice";
import "core-js/modules/es.function.name";
import "core-js/modules/es.object.keys";
import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.string.replace";
import "core-js/modules/web.dom-collections.for-each";
import _defineProperty from "D:/mzkj/\u8981\u70BC/yl-pc-business/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _objectSpread from "D:/mzkj/\u8981\u70BC/yl-pc-business/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/mzkj/\u8981\u70BC/yl-pc-business/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _toConsumableArray from "D:/mzkj/\u8981\u70BC/yl-pc-business/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var initForm = {
  goodsName: '',
  goodsSlogan: '',
  brandId: '',
  refundWithoutReason: '',
  exchangeGoods: '',
  goodsModel: '',
  sellAttributes: [],
  goodsImages: [],
  goodsPrimaryVideo: '',
  goodsContentApp: '',
  deliveryFeeId: '',
  storeGoodsTypeId: '',
  storeGoodsTypeFirst: '',
  packingList: '',
  afterSaleService: '',
  onlyVatInvoice: false,
  autoOnShelf: false,
  autoOffShelf: false,
  autoOnShelfTime: '',
  autoOffShelfTime: '',
  goodsStatus: '',
  goodsItems: []
};
var tabDefalut = [{
  label: '商品条形码',
  prop: 'goodsBarcode',
  edit: true,
  type: 'd2Input'
}, {
  label: '出售价',
  prop: 'goodsPrice',
  edit: true,
  type: 'd2Input'
}, {
  label: '库存',
  prop: 'goodsStock',
  edit: true,
  type: 'd2Input'
}, {
  label: '重量（可不填）',
  prop: 'goodsWeight',
  edit: true,
  type: 'd2Input'
}, {
  label: '商家SKU（可不填）',
  prop: 'goodsSku',
  edit: true,
  type: 'd2Input'
}];
import { cloneDeep } from 'lodash';
import editTable from '../comps/editTable.vue';
import uploadVideo from '../comps/uploadVideo.vue';
import setRules from '@/libs/rules';
var rule = [// { key: 'accountPhone', name: '手机号码', validator: 'validatePhone' },
{
  key: 'goodsName',
  name: '商品名称'
}, {
  key: 'goodsSlogan',
  name: '商品标语'
}, {
  key: 'refundWithoutReason'
}, {
  key: 'exchangeGoods'
}, {
  key: 'goodsContentApp'
}, {
  key: 'deliveryFeeId'
}];
export default {
  meta: {
    title: '添加新商品',
    auth: true,
    authorityValue: 'store-goods-add'
  },
  name: 'newAddTrade',
  components: {
    editTable: editTable,
    uploadVideo: uploadVideo
  },
  data: function data() {
    return {
      brandOptions: [],
      //品牌列表
      tableProp: _toConsumableArray(cloneDeep(tabDefalut)),
      treeOptions: [],
      defaultProps: {
        label: 'typeName',
        value: 'goodsTypeId',
        lazy: true,
        lazyLoad: this.treeLoad
      },
      deliveryOptions: [],
      formData: cloneDeep(initForm),
      rules: setRules(rule),
      checked: true,
      imgAttr: {
        width: 90,
        height: 90,
        isSingle: true
      },
      imgAttrs: {
        width: 90,
        height: 90,
        limit: 10,
        tradeList: true
      },
      attrList: [],
      dataList: []
    };
  },
  computed: {
    goodsTit: function goodsTit() {
      return this.$route.query.goodsTit;
    },
    deliveryName: function deliveryName() {
      var _this = this;

      if (!this.formData.deliveryFeeId) return;
      var item = this.deliveryOptions.find(function (v) {
        return v.deliveryFeeId == _this.formData.deliveryFeeId;
      });
      return item.deliveryFeeName;
    },
    deliveryTip: function deliveryTip() {
      var _this2 = this;

      if (!this.formData.deliveryFeeId) return;
      var item = this.deliveryOptions.find(function (v) {
        return v.deliveryFeeId == _this2.formData.deliveryFeeId;
      });
      var t = "\u6309\u91CD\u91CF\uFF1A\u9ED8\u8BA4\u8FD0\u8D39".concat(item.baseCount, "\u5343\u514B\uFF08kg\uFF09\u5185").concat(item.basePrice, "\u5143\uFF0C\u6BCF\u589E\u52A0").concat(item.incrementCount, "\u5343\u514B\uFF08kg\uFF09\uFF0C\u589E\u52A0\u8FD0\u8D39").concat(item.incrementPrice, "\u5143");
      var g = "\u6309\u4EF6\u6570\uFF1A\u9ED8\u8BA4\u8FD0\u8D39".concat(item.baseCount, "\uFF08\u4EF6\uFF09\u5185").concat(item.basePrice, "\u5143\uFF0C\u6BCF\u589E\u52A0").concat(item.incrementCount, "\uFF08\u4EF6\uFF09\uFF0C\u589E\u52A0\u8FD0\u8D39").concat(item.incrementPrice, "\u5143");
      var tit = item.feeType == 1 ? g : t;
      return item.freed ? '卖家承担' : tit;
    }
  },
  methods: {
    onSubmit: function onSubmit(item) {
      var _this3 = this;

      if (this.formData.goodsPrimaryVideo && !this.formData.goodsPrimaryVideoCover) {
        YL.message('上传视频请同步上传视频封面', 'error');
        return;
      }

      if (!this.formData.goodsPrimaryVideo && this.formData.goodsPrimaryVideoCover) {
        YL.message('上传视频封面请同步上传视频', 'error');
        return;
      }

      console.log(this.formData);
      this.$refs.formData.validate( /*#__PURE__*/function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(valid) {
          var params, _yield$_this3$$api$de, records, noWeight, goodsImages;

          return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  if (valid) {
                    _context.next = 2;
                    break;
                  }

                  return _context.abrupt("return");

                case 2:
                  params = _objectSpread(_objectSpread(_objectSpread({}, _this3.formData), item), {}, {
                    sellAttributes: _this3.attrList
                  }); //获取运费模板

                  _context.next = 5;
                  return _this3.$api.deliveryFees(_objectSpread({
                    pageSize: 999
                  }, item));

                case 5:
                  _yield$_this3$$api$de = _context.sent;
                  records = _yield$_this3$$api$de.records;
                  // 判断选择的运费模板是否是按重量
                  noWeight = true;
                  records.forEach(function (e) {
                    if (e.deliveryFeeId === params.deliveryFeeId) {
                      console.log('运费方式', e.feeType);

                      if (e.feeType === 2) {
                        params.goodsItems.forEach(function (_e) {
                          if (_e.goodsWeight == '') noWeight = false;
                        });
                      }
                    }
                  });

                  if (noWeight) {
                    _context.next = 11;
                    break;
                  }

                  return _context.abrupt("return", _this3.$message.error('由于您选择按重量计算运费，请完善商品重量'));

                case 11:
                  // 过滤商品图片数组中的null
                  goodsImages = [];
                  params.goodsImages.forEach(function (e) {
                    if (e !== null) {
                      goodsImages.push(e);
                    }
                  });
                  params.goodsImages = goodsImages;
                  _context.next = 16;
                  return _this3.$api.saveGoods(params);

                case 16:
                  YL.message('保存成功');

                  _this3.goBack();

                  if (item.goodsStatus == 1) _this3.$router.replace('/saleTrade');else _this3.$router.replace('/comsTrade');

                case 19:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }));

        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
    },
    tabDelete: function tabDelete(item, $index) {
      this.formData.goodsItems.splice($index, 1);
    },
    imgEmit: function imgEmit(list) {
      console.log(list);
    },
    imgEmits: function imgEmits(list) {
      console.log(list);
    },
    d2Upload: function d2Upload() {
      this.$refs.d2Upload.elUploadClick(null, null);
    },
    //获取品牌列表
    getBrands: function getBrands() {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var _yield$_this4$$api$br, records, record;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return _this4.$api.brands({
                  pageSize: 999
                });

              case 2:
                _yield$_this4$$api$br = _context2.sent;
                records = _yield$_this4$$api$br.records;
                record = [];
                records.forEach(function (e) {
                  if (e.brandActivate) {
                    record.push(e);
                  }
                });
                _this4.brandOptions = record;

              case 7:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    //添加规格值
    addSellAttributes: function addSellAttributes(item) {
      var _this5 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _this5.$prompt('添加后不可删除，请谨慎添加', '提示', {
                  confirmButtonText: '确定',
                  cancelButtonText: '取消',
                  inputPattern: /\S/,
                  inputErrorMessage: '不可为空'
                }).then( /*#__PURE__*/function () {
                  var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(_ref2) {
                    var value, params;
                    return regeneratorRuntime.wrap(function _callee3$(_context3) {
                      while (1) {
                        switch (_context3.prev = _context3.next) {
                          case 0:
                            value = _ref2.value;
                            params = {
                              sellAttributeId: item.sellAttributeId,
                              itemValue: value,
                              itemSort: 0
                            };
                            _context3.next = 4;
                            return _this5.$api.saveSellAttributeItem(params);

                          case 4:
                            _this5.getSellAttributes();

                          case 5:
                          case "end":
                            return _context3.stop();
                        }
                      }
                    }, _callee3);
                  }));

                  return function (_x2) {
                    return _ref3.apply(this, arguments);
                  };
                }());

              case 1:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }))();
    },
    //获取属性列表
    getSellAttributes: function getSellAttributes() {
      var _this6 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
        var query, _yield$_this6$$api$se, records;

        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _this6.attrList = [];
                query = _this6.$route.query;
                _context6.next = 4;
                return _this6.$api.sellAttributes({
                  goodsTypeId: query.goodsTypeId ? query.goodsTypeId : query.goodsTypeIdSecond ? query.goodsTypeIdSecond : query.goodsTypeIdFirst
                });

              case 4:
                _yield$_this6$$api$se = _context6.sent;
                records = _yield$_this6$$api$se.records;

                try {
                  cloneDeep(records).forEach( /*#__PURE__*/function () {
                    var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(v) {
                      var params, data;
                      return regeneratorRuntime.wrap(function _callee5$(_context5) {
                        while (1) {
                          switch (_context5.prev = _context5.next) {
                            case 0:
                              params = {
                                sellAttributeId: v.sellAttributeId,
                                pageSize: 1000 * 1000
                              };
                              _context5.next = 3;
                              return _this6.$api.sellAttributeDetails(params);

                            case 3:
                              data = _context5.sent;

                              _this6.attrList.push(data);

                            case 5:
                            case "end":
                              return _context5.stop();
                          }
                        }
                      }, _callee5);
                    }));

                    return function (_x3) {
                      return _ref4.apply(this, arguments);
                    };
                  }());
                } catch (_unused) {
                  _this6.attrList = cloneDeep(records);
                }

              case 7:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6);
      }))();
    },
    changeCheckbox: function changeCheckbox(e, k) {
      var _this7 = this;

      this.formData.sellAttributes = [];
      this.dataList = cloneDeep(this.formData.goodsItems);
      this.formData.goodsItems = [];
      this.tableProp = cloneDeep(tabDefalut);
      var tableList = [];
      this.attrList.forEach(function (v) {
        if (v.items.some(function (s) {
          return s.selected;
        })) {
          tableList.push(_objectSpread(_objectSpread({}, v), {}, {
            items: v.items.filter(function (f) {
              return f.selected;
            })
          }));
        }
      });
      var tabObj = {};
      tableList.forEach(function (v) {
        tabObj[v.attributeName] = v.items.map(function (m) {
          return m.itemValue;
        });
        var tab = {
          label: v.attributeName,
          prop: v.attributeName,
          width: '100px'
        };

        _this7.tableProp.unshift(tab);
      }); // 循环每一个商品属性

      var result = this.combination(tabObj);
      result.forEach(function (v) {
        var obj = _objectSpread(_objectSpread({}, v), {}, {
          goodsItemId: '',
          itemSellAttributes: [],
          goodsBarcode: '',
          goodsPrice: '',
          goodsStock: '',
          goodsWeight: '',
          goodsSku: ''
        });

        _this7.dataList.forEach(function (d) {
          var isold = true;

          for (var key in v) {
            if (v[key] === k.itemValue) {
              if (d[key] !== undefined) {
                isold = false;
              }
            } else {
              if (v[key] !== d[key]) {
                isold = false;
              }
            }
          }

          if (isold) {
            var p = {
              goodsBarcode: d.goodsBarcode,
              goodsPrice: d.goodsPrice,
              goodsStock: d.goodsStock,
              goodsWeight: d.goodsWeight,
              goodsSku: d.goodsSku
            };
            obj = _objectSpread(_objectSpread(_objectSpread({}, obj), p), {}, {
              itemSellAttributes: obj.itemSellAttributes
            });
          }
        });

        _this7.formData.goodsItems.push(obj);
      });
      this.dataList = cloneDeep(this.formData.goodsItems);
      this.attrList.forEach(function (v) {
        _this7.formData.goodsItems.forEach(function (f) {
          Object.keys(f).forEach(function (k) {
            if (v.attributeName == k) {
              var item = v.items.find(function (s) {
                return s.itemValue == f[k];
              });
              f.itemSellAttributes.push(item);
            }
          });
        });
      });
      this.formData.sellAttributes = tableList;
      this.$forceUpdate();
    },
    //排列组合
    combination: function combination(tabObj) {
      return Object.keys(tabObj).reduce(function (result, key) {
        // 循环属性的每一个值
        return tabObj[key].reduce(function (acc, value) {
          // 对于第一个属性
          if (!result.length) {
            // 将数值转化为对象格式
            return acc.concat(_defineProperty({}, key, value));
          } // 对于第一个之后的属性，将新的属性和值添加到已有结果，并进行拼接。


          return acc.concat(result.map(function (ele) {
            return Object.assign({}, ele, _defineProperty({}, key, value));
          }));
        }, []);
      }, []);
    },
    //获取店内分类
    storeGoodsTypes: function storeGoodsTypes(item, resolve) {
      var _this8 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
        var _yield$_this8$$api$st, records;

        return regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.next = 2;
                return _this8.$api.storeGoodsTypes(_objectSpread({
                  pageSize: 999
                }, item));

              case 2:
                _yield$_this8$$api$st = _context7.sent;
                records = _yield$_this8$$api$st.records;
                resolve && resolve(records);

              case 5:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7);
      }))();
    },
    treeLoad: function treeLoad(e, resolve) {
      var params = {
        typeLevel: 1
      };

      if (e) {
        params = _objectSpread(_objectSpread({}, params), {}, {
          preTypeId: e.value,
          typeLevel: e.value ? '' : 1
        });
      }

      this.storeGoodsTypes(params, resolve);
    },
    treeCheck: function treeCheck(e) {
      e[0] && this.$set(this.formData, 'storeGoodsTypeFirst', e[0]);
      e[1] && this.$set(this.formData, 'storeGoodsTypeId', e[1]);
    },
    //获取运费模板
    deliveryFees: function deliveryFees(item) {
      var _this9 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8() {
        var _yield$_this9$$api$de, records;

        return regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _context8.next = 2;
                return _this9.$api.deliveryFees(_objectSpread({
                  pageSize: 999
                }, item));

              case 2:
                _yield$_this9$$api$de = _context8.sent;
                records = _yield$_this9$$api$de.records;
                _this9.deliveryOptions = records;

              case 5:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8);
      }))();
    },
    // 图片上传
    handleSuccess: function handleSuccess(response, key) {
      this.$set(this.formData, key, this.VUE_APP_IMG_BASE + response.key);
      this.$refs['layerForm'].clearValidate(key);
    },
    beforeUpload: function beforeUpload(file) {
      if (!YL.beforeUploadCommon(file, 'pic')) return false;
      this.uploadData.data.key = new Date().getTime() + YL.catchType(file.name);
    }
  },
  created: function created() {
    var _this10 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9() {
      var query;
      return regeneratorRuntime.wrap(function _callee9$(_context9) {
        while (1) {
          switch (_context9.prev = _context9.next) {
            case 0:
              _context9.next = 2;
              return _this10.getQiNiu();

            case 2:
              query = _this10.$route.query;
              _this10.formData = Object.assign(_this10.formData, query);

              _this10.getBrands();

              _this10.deliveryFees();

              _this10.getSellAttributes();

            case 7:
            case "end":
              return _context9.stop();
          }
        }
      }, _callee9);
    }))();
  }
};